export default {
    setCarBrandsData(state, payload) {
        state.carBrands = payload.data;
    },
  setCarCategoriesData(state, payload) {
    state.carCategories = payload.data;
  },
};
